import React from 'react';

export default () => (
	<div className="d-flex justify-content-center">
		<div className="spinner-grow text-success">
			<span className="sr-only">Loading...</span>
		</div>
	</div>
);
